/*! @azure/msal-common v8.0.0 2022-11-07 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var CcsCredentialType;
(function (CcsCredentialType) {
    CcsCredentialType["HOME_ACCOUNT_ID"] = "home_account_id";
    CcsCredentialType["UPN"] = "UPN";
})(CcsCredentialType || (CcsCredentialType = {}));

export { CcsCredentialType };
//# sourceMappingURL=CcsCredential.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@azure/msal-common/dist/account/CcsCredential.js
// module id = 53
// module chunks = 0